import { Box } from "@mui/system";
import React, { useState, useEffect } from "react";
import {
  createTableFilterList,
  getIncidentsData,
  isItGateway,
  getImageObj,
} from "../../utility/Utils";
import GmtToLocal from "../../utility/GmtToLocal";
import { styles } from "../../utility/styleUtils";
import "../../../styles/cameraSnapshot.css";
import { Icon } from "@vds/icons";
import { Badge } from "@vds-core/badges";
import { Button } from "@vds/buttons";
import { CustomTable } from "./CustomTable";
import {
  getFieldOfVisions,
  getFields,
  getLocation,
  getRecord,
  getCompanion,
  getDeviceDetails,
  sortAndSetAlertList,
} from "../../utility/tableUtils";
import {
  getDevicesPageTableColumns,
  getGatewaysDetailsDeviceTableColumns,
  getHealthScorePagesDeviceTableColumns,
  getSensorsDetailDeviceTableColumns,
  getCameraDetailDeviceTableColumns,
  getCompanionDeviceDetailsDeviceTableColumns,
  getAssociateCameraColumns,
  getDiscoverCameraTableColumns,
  getCompanionTableColumns,
  getCamerasTableColumns,
} from "../../../model/deviceTableColumns";
import { useNavigate } from "react-router-dom";
import { TextLink } from "@vds/buttons";
import { InlineCheckbox } from "../../utility/styledComponents";
import { SearchWithButton } from "../../../pages/NewCameraInfo";
import { Toggle } from "@vds/toggles";
import People from "../../../assets/peopleCount.png";
import Fall from "../../../assets/fall-detection.png";
import Smoke from "../../../assets/smoke-detection.svg";
import Image from "../../../assets/no snapshot.png";
import moment from "moment-timezone";
import { Body, Title } from "@vds/typography";
import { Tooltip } from "antd";
import { unpairCameraEndPoint } from "../../../configuration";
import { useSelector, useDispatch } from "react-redux";
import { getCompanionObjectbyId } from "../../utility/devicesUtils";
import { deleteItem } from "../../../api/SessionServiceManager";
import { Notification } from "@vds/notifications";
import NotificationBanner from "../../../layouts/NotificationBanner";
import { hasPermission } from "../../utility/permissionUtils";
import { showNotificationBanner } from "../../../store/actions";
import { PAGE_IDENTIFIERS } from "../../constants/tableConstants";
import { MONTH_DATE_YEAR_HR_MIN_SEC_AM, HR_MIN_AM, DATE_FORMAT_MMDDYYYY } from "../../constants/statistics.dateConstants";

const { CAMERA_EVENTS } = PAGE_IDENTIFIERS;

const DevicesTable = (props) => {
  const {
    deviceList: devcieList1,
    incidentList: incidentListItems,
    setRefreshDeviceTable,
    tableLoading,
    searchInputText,
    tableTitle,
    hasRefreshIcon,
    pageName,
    state,
    cameraId,
    showOptionalCheckbox,
    onCheckboxChange,
    searchColumns = [
      "name",
      "Camera",
      "id",
      "Streams",
      "createdon",
      "state",
      "nickname",
      "uid",
      "location",
      "Fields of Vision",
      "Apps",
      "Last Message",
      "Firmware",
      "Streams",
      "Camera ID",
      "refId",
    ],
    setSearchSensor,
    onButtonClick,
    displayListType,
    buttonDisable,
    buttonLabel,
    filterDeviceTag,
    containerStyle,
    ellipsis,
    handlePageClick,
    totalIncidentCount,
    itemsPerPage,
  } = props;
  // TO Do - temp change will be removed once score property is available in api
  const deviceList = devcieList1?.map((item) => {
    return {
      ...item,
      ["score"]: String(Math.floor(Math.random() * (101 - 40) + 40) + "%"),
    };
  });
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const storeDeviceList = useSelector(
    (state) => state.deviceReducer.deviceList
  );
  const [incidentList, setIncidentList] = useState(incidentListItems || []);
  const [filteredInfo, setFilteredInfo] = useState([]);
  const [showTableFilter, setShowTableFilter] = useState(true);
  const [toggle, setToggle] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showNotification, setShowNotification] = useState(false);
  const parentDeviceList = JSON.parse(sessionStorage.getItem("deviceList"));
  const filterDeviceList = (deviceId, type) => {
    let value = "0";
    const deviceList = [...parentDeviceList];
    deviceList.filter((device) => {
      if (device.id === deviceId) {
        value = device.fields ? device.fields[type] : false;
      }
    });
    return value ? value + "%" : "----";
  };

  const handleDelete = async (cameraItem, record) => {
    try {
      const companion = getCompanionObjectbyId(
        cameraItem.parentdeviceid,
        storeDeviceList
      )[0];
      let companionidentifier = {};
      companionidentifier[companion.refidtype] = companion?.refid;
      let cameraidentifier = {};
      cameraidentifier[cameraItem.refidtype] = cameraItem?.refid;
      const body = {
        accountname: activeSession.accountId,
        companionidentifier: companionidentifier,
        cameraidentifier: cameraidentifier,
      };
      const response = await deleteItem(unpairCameraEndPoint(), body);
      if (response.statusText === "OK") {
        // Update the state to remove the deleted record
        const updatedList = deviceList.filter((item) => item.id !== record.id);
        setIncidentList(updatedList);
        setRefreshDeviceTable(true);
        console.log("Camera unpaired successfully");
      } else {
        console.error("Failed to unpair camera");
      }
    } catch (error) {
      console.error("Error unpairing camera:", error);
    }
  };

  // useEffect(() => {
  //   if (incidentList.length === 0) {
  //     callIncidentsApi();
  //   }
  // }, []);

  // const callIncidentsApi = async () => {
  //   try {
  //     setIncidentList([]);
  //     const fetchIncidentsRsp = await getIncidentsData();

  //     const status = fetchIncidentsRsp.status;

  //     if (status == 401) {
  //       navigate("/login");
  //     }
  //     if (!fetchIncidentsRsp.error) {
  //       let incidentList = fetchIncidentsRsp;
  //       for (let i = 0; i < incidentList.length; i++) {
  //         let deviceName = getDeviceDetails(
  //           deviceList,
  //           incidentList[i].deviceid
  //         );
  //         let alertDetails = {};
  //         alertDetails.devicename = deviceName?.name;
  //         alertDetails.device = deviceName;
  //         incidentList[i].createdAt = GmtToLocal(incidentList[i].createdAt);
  //         incidentList[i] = { ...incidentList[i], ...alertDetails };
  //       }
  //       const evidenceList = incidentList.filter(
  //         (item) =>
  //           item?.evidences &&
  //           item.evidences.length > 0 &&
  //           item.evidences.some(
  //             (evidence) => evidence.sourceId === state?.data?.refid
  //           )
  //       );
  //       // setEvidences(evidenceList);
  //       console.log("incidentList", incidentList);
  //       setIncidentList([...sortAndSetAlertList(incidentList)]);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const handleToggle = (e, data) => {
    // debugger;
    const oldToggle = [...toggle];
    const toggleIndex = oldToggle.findIndex((f) => f.qrcode === data.qrcode);
    if (toggleIndex !== -1) {
      oldToggle[toggleIndex].switch = e.target.checked;
    } else {
      oldToggle.push({
        qrcode: data.qrcode,
        switch: e.target.checked,
      });
    }
    setToggle(oldToggle);
  };
  const handleTableChange = (pagination, filters, sorter) => {
    handlePageClick(pagination.current);
  };
  const handlerFiltedAction = () => {
    setShowTableFilter(!showTableFilter);
    if (showTableFilter) {
      setFilteredInfo([]);
    }
  };
  const formatDate = (inputDate) => {
    const timeZone = moment.tz.guess();
    const date = moment(inputDate, MONTH_DATE_YEAR_HR_MIN_SEC_AM).tz(timeZone);
    const formattedTime = date.format(`${HR_MIN_AM} z`);
    const formattedDate = date.format(DATE_FORMAT_MMDDYYYY);
    return `${formattedTime}, ${formattedDate}`;
  };

  const getDuration = (activities, eventCreatedAt) => {
    let duration = "";
    const resolvedAct = activities?.find((act) => act?.action === "Resolved");
    if (resolvedAct && eventCreatedAt) {
      const date1 = moment(eventCreatedAt);
      const date2 = moment(resolvedAct.createdAt);
      const ms = moment.duration(date2.diff(date1));
      const days = Math.floor(ms.asDays());
      const hours = Math.floor(ms.asHours() % 24);
      const minutes = Math.floor(ms.asMinutes() % 60);
      const sec = Math.floor(ms.asSeconds() % 60);

      const dayOrDays = days === 1 ? "day" : "days";
      const hourOrHours = hours === 1 ? "hr" : "hrs";
      const minOrMins = minutes === 1 ? "min" : "mins";
      const secOrSecs = sec === 1 ? "sec" : "secs";

      if (days > 0) {
        duration = `${days}${dayOrDays}  ${hours}${hourOrHours}  ${minutes}${minOrMins}  ${sec}${secOrSecs}`;
      } else if (days <= 0 && hours > 0) {
        duration = `${hours}${hourOrHours}  ${minutes}${minOrMins}  ${sec}${secOrSecs}`;
      } else if (days <= 0 && hours <= 0) {
        duration = `${minutes}${minOrMins}  ${sec}${secOrSecs}`;
      }
    } else {
      duration = "ongoing";
    }
    return duration;
  };

  const getTextValue = (title, record, text, item) => {
    const currentTitle = title?.toLowerCase();
    let textValue = text;
    switch (currentTitle) {
      case "location":
        textValue = getLocation(record.uid, deviceList);
        break;
      case "device status":
      case "status":
        // textValue = text?.toLowerCase() === "ready" ? "Online" : "Offline";
        const statusColor = getStatusColor(text);
        textValue =
          pageName === CAMERA_EVENTS ? (
            <span style={{ marginLeft: "10px" }}>
              <Badge fillColor={`${statusColor}`}>{text}</Badge>
            </span>
          ) : (
            <span style={{ marginLeft: "10px" }}>
              <Badge fillColor="green">
                {text?.toLowerCase() === "ready" ? "Online" : "New"}
              </Badge>
            </span>
          );
        break;
      case "severity":
        // textValue = text?.toLowerCase() === "ready" ? "Online" : "Offline";
        const priorityColor = getPriorityColor(text);
        textValue = (
          <span style={{ marginLeft: "10px" }}>
            <Badge fillColor={`${priorityColor}`}>
              {text === "Low" || text === "Elevated" ? "Minor" : text}
            </Badge>
          </span>
        );
        break;
      case "last alert":
        textValue = GmtToLocal(text);
        break;
      case "duration":
        textValue = getDuration(record?.activity, record?.createdAt);
        break;
      case "stream":
        textValue = text;
        break;
      case "time & date":
        textValue = formatDate(text);
        break;
      case "battery":
      case "signal":
        textValue = filterDeviceList(text, item.filterByText);
        break;
      default:
        textValue = text;
        break;
    }
    return textValue;
  };

  const tableMetaDataInfo = {
    showTableFilter,
    filteredInfo,
    deviceList,
    incidentList,
    createTableFilterList,
    GmtToLocal,
  };

  const getColumnDetails = (pageName) => {
    switch (pageName) {
      case "gatewayInfo":
      case "gatewayHealthScoreDetails":
        return getGatewaysDetailsDeviceTableColumns({
          ...tableMetaDataInfo,
          pageName,
        });
      case "sensorInfo":
      case "sensorHealthScoreDetails":
        return getSensorsDetailDeviceTableColumns({
          ...tableMetaDataInfo,
          getLocation,
          pageName,
        });
      case "gatewaysHealthScore":
      case "sensorsHealthScore":
        return getHealthScorePagesDeviceTableColumns({
          ...tableMetaDataInfo,
          getLocation,
          pageName,
        });
      case "companionDeviceInfo":
        return getCompanionDeviceDetailsDeviceTableColumns({
          ...tableMetaDataInfo,
          pageName,
        });
      case CAMERA_EVENTS:
        return getCameraDetailDeviceTableColumns({
          ...tableMetaDataInfo,
          getLocation,
          pageName,
        });
      case "AssociateCameras":
        return getAssociateCameraColumns({
          ...tableMetaDataInfo,
          getLocation,
          pageName,
        });
      case "DiscoveredCameras":
        return getDiscoverCameraTableColumns({
          ...tableMetaDataInfo,
          getLocation,
          showOptionalCheckbox,
          pageName,
        });
      case "CompanionDevices":
        return getCompanionTableColumns({
          ...tableMetaDataInfo,
          getLocation,
          showOptionalCheckbox,
          deviceList,
          pageName,
        });
      case "Cameras":
        return getCamerasTableColumns({
          ...tableMetaDataInfo,
          getLocation,
          showOptionalCheckbox,
          pageName,
          parentDeviceList,
        });
      default:
        const data = getDevicesPageTableColumns({
          ...tableMetaDataInfo,
          getLocation,
          showOptionalCheckbox,
          pageName,
        });

        return data;
    }
  };

  const columnDetails = getColumnDetails(pageName, showOptionalCheckbox);

  const getTabNames = (record) => {
    return record?.tagids?.map((t, i) => {
      return (
        t?.name && (
          <React.Fragment key={i}>
            <span
              onClick={() => {
                filterDeviceTag({
                  id: t?.id,
                  name: t?.name,
                });
              }}
              style={{ cursor: "pointer" }}
            >
              <Badge
                fillColor="black"
                maxWidth="fit-content"
                width="fit-content"
              >
                {`${t?.name} `}
              </Badge>
            </span>
          </React.Fragment>
        )
      );
    });

    {
    }
  };
  const getPriorityColor = (priority) => {
    let priorityColor = "green";
    if (priority === "Low") {
      priorityColor = "blue";
    } else if (priority === "Critical") {
      priorityColor = "orange";
    } else {
      priorityColor = "yellow";
    }
    return priorityColor;
  };
  const getStatusColor = (status) => {
    let statusColor = "";
    if (status === "Unresolved") {
      statusColor = "black";
    } else if (status === "resolved") {
      statusColor = "";
    }
    return statusColor;
  };
  const renderedColumns = columnDetails.map((item, index) => {
    if (item.children) {
      const childrenColumns = item.children.map((child) => {
        return {
          ...child,
          render: (text, record) => (
            <span>{record[item.dataIndex]?.[child.dataIndex]}</span>
          ),
        };
      });
      return {
        ...item,
        children: childrenColumns,
      };
    }
    const {
      title,
      showCheckBox,
      customStyle,
      isLink,
      navLinks,
      hasInfoLink,
      isDelete,
      isToggle,
      ellipsis,
    } = item;
    if (title === "Snapshot") {
      return {
        ...item,
        title: () => {
          return (
            <Title bold={true} size="small">
              {title}
            </Title>
          );
        },

        render: (images, record) => {
          const toggleInfo = toggle.find((t) => t.qrcode === record.qrcode);
          if (toggleInfo) {
            if (!toggleInfo.switch) {
              return (
                <img
                  width=""
                  src={Image}
                  style={{ width: "312px", height: "173px" }}
                />
              );
            }
          }
          if (toggleInfo === undefined) {
            return (
              <img src={Image} style={{ width: "312px", height: "173px" }} />
            );
          }
          return (
            <div>
              {images?.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Image ${index + 1}`}
                  className="camera-snapshot-table"
                />
              ))}
            </div>
          );
        },
      };
    } else if (title === "Stream ID") {
      return {
        ...item,
        title: () => {
          return (
            <div className="sasp_font-size-14 sasp_font-weight-bold">
              {title}
            </div>
          );
        },

        render: (fov) => {
          if (Array.isArray(fov)) {
            if (title === "Stream ID") {
              return (
                <ul>
                  {fov.map((item, index) => (
                    <div key={item.id}>
                      {fov.length > 1 ? (
                        <span className="streams">{`Stream ${
                          index + 1
                        }: `}</span>
                      ) : (
                        ""
                      )}
                      {item.id}
                    </div>
                  ))}
                </ul>
              );
            }
            return <span>{fov.length}</span>;
          }
        },
      };
    } else if (title === "Companion") {
      return {
        ...item,
        title: () => {
          return (
            <Title bold={true} size="small">
              {title}
            </Title>
          );
        },

        render: (id) => {
          const list = getCompanion(id, parentDeviceList);

          if (list.length) {
            return (
              <ul className="companionStyle">
                {list.map((item, index) => (
                  <div key={index}>{item.name}</div>
                ))}
              </ul>
            );
          } else {
            return <></>;
          }
        },
      };
    } else if (title == "Apps") {
      return {
        ...item,
        title: () => {
          return (
            <Title bold={true} size="small">
              {title}
            </Title>
          );
        },
        render: (apps) => {
          return (
            <div>
              {" "}
              <ul className="cvapps">
                <li>
                  <img src={People} style={{ width: "16px", height: "16px" }} />
                </li>
                <li>
                  <img src={Fall} style={{ width: "16px", height: "16px" }} />
                </li>
                <li>
                  <img src={Smoke} style={{ width: "16px", height: "16px" }} />
                </li>
                {/* <li><img src={Person} style={{ width: '16px', height: '16px' }} /></li>
            <li><img src={Door} style={{ width: '16px', height: '16px' }} /></li>
            <li><img src={Smoke} style={{ width: '16px', height: '16px' }} /></li> */}
              </ul>
            </div>
          );

          //  return apps.map(s =>{
          //   // return <>{s.appName}</>
          //   return <img src={People} style={{ width: '16px', height: '16px' }} />

          //  })
        },
      };
    } else if (title === "Streams" || title === "Fields of Vision") {
      return {
        ...item,
        title: () => {
          return (
            <Title bold={true} size="small">
              {title}
            </Title>
          );
        },

        render: (id) => {
          const list = getFieldOfVisions(id, parentDeviceList);

          return (
            <>
              {list.length > 0 &&
                list.map((l, id) => {
                  return (
                    <ul key={id} className="fieldsofVision">
                      <Tooltip
                        placement="bottomLeft"
                        autoAdjustOverflow="false"
                        title={l.name}
                      >
                        <span>{l.name}</span>
                      </Tooltip>
                    </ul>
                  );
                })}
            </>
          );
        },
      };
    } else {
      return {
        ...item,
        title: () => {
          return (
            <Title bold={true} size="small">
              {title}
            </Title>
          );
        },

        render: (text, record) => {
          const state =
            pageName === "gatewayInfo"
              ? {
                  data: getRecord(record, parentDeviceList),
                  title: `More info for ${record.name}`,
                  fields: getFields(record, parentDeviceList) || {},
                }
              : {
                  data: { ...record, cameraId },
                  title: `More info for ${record.name}`,
                  fields: record?.fields || {},
                };
          let linkUrl = isLink ? navLinks.url : "";
          //if (hasInfoLink) {
          if (hasInfoLink && record.id !== "dummyGateway") {
            //TODO: only for demo. Disable clickable links for gateway and sensor tables
            linkUrl = isItGateway(record)
              ? navLinks.gatewayInfo
              : navLinks.sensorInfo;
          }

          const textValue = getTextValue(title, record, text, item) || text;
          let textColor = "";
          let fontWeight = "sasp_font-weight-400";
          if (title?.toLowerCase() === "score") {
            fontWeight = "sasp_font-weight-bold";
            if (Number(textValue.split("%")[0]) > 90) {
              textColor = `sasp_health-score-good-text-color`;
            }
            if (Number(textValue.split("%")[0]) <= 90) {
              textColor = `sasp_health-score-yellow-text-color`;
            }
            if (Number(textValue.split("%")[0]) <= 80) {
              textColor = `sasp_health-score-orange-text-color`;
            }
            if (Number(textValue.split("%")[0]) <= 50) {
              textColor = `sasp_health-score-red-text-color`;
            }
          }
          return (
              <div style={{ display: "flex", ...containerStyle }}>
                {showCheckBox && (
                  <InlineCheckbox
                    width="auto"
                    onChange={(e) => onCheckboxChange(e, record)}
                    checked={record.checkboxSelected}
                    disabled={record.checkboxDisabled}
                  />
                )}
                {isLink && !ellipsis && (
                  <div className="d-flex flex-column">
                    <div>
                      <TextLink
                        type="standAlone"
                        onClick={() => {
                          if (linkUrl === "/eventsInfo") {
                            const fromParam = pageName === CAMERA_EVENTS && state?.data?.cameraId?.trim() ? `&cameraId=${encodeURIComponent(state.data.cameraId.trim())}` : "";
                            navigate(`/eventsInfo?eventid=${encodeURIComponent(state?.data?.id)}${fromParam}`);
                          } else {
                            navigate(linkUrl, { state });
                          }

                          // linkUrl == "/eventsInfo"
                          //   ? navigate(linkUrl, { state: state.data })
                          //   : navigate(linkUrl, { state });
                        }}
                        size="large"
                        className="link"
                        style={{
                          ...customStyle,
                          // ...styles.textBoldUnderline,
                          //borderBottomStyle: "none",
                          textDecoration: "none",
                          marginLeft: showCheckBox ? 10 : "",
                        }}
                      >
                        {textValue}
                      </TextLink>
                      <sup>
                        {record?.tagids?.length > 0 && getTabNames(record)}
                      </sup>
                    </div>
                  </div>
                )}
                {!isLink && !isDelete && (
                  <h5
                    style={{ ...customStyle }}
                    className={`sasp_font-size-14 ${fontWeight} ${textColor}`}
                  >
                    {textValue}
                  </h5>
                )}
                {ellipsis && isLink && (
                  <Tooltip
                    placement="bottomLeft"
                    autoAdjustOverflow="false"
                    title={textValue}
                  >
                    <TextLink
                      type="standAlone"
                      onClick={() => navigate(linkUrl, { state })}
                      size="large"
                      className="link"
                      style={{
                        ...customStyle,
                        // ...styles.textBoldUnderline,
                        //borderBottomStyle: "none",
                        textDecoration: "underline",
                        marginLeft: showCheckBox ? 10 : "",
                      }}
                    >
                      <Body size="large" viewport="desktop" primitive="span">
                        {textValue}
                      </Body>
                    </TextLink>
                  </Tooltip>
                )}
                {!isLink && ellipsis && (
                  <Tooltip
                    placement="topLeft"
                    autoAdjustOverflow="false"
                    title={textValue}
                  >
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        ...customStyle,
                        // width: "100%",
                      }}
                    >
                      <Body size="large" viewport="desktop" primitive="span">
                        {textValue}
                      </Body>
                    </div>
                  </Tooltip>
                )}
                {!!isDelete && (
                  <div
                    onClick={() => {
                      if (!hasPermission("Cameras", "Delete")) {
                        showPermissionsBanner();
                      } else {
                        handleDelete(record);
                      }
                    }}
                  >
                    <Icon name="trash" size="medium" color="#000000" />
                  </div>
                )}
                {!!isToggle && (
                  <div
                    onChange={(e) => {
                      handleToggle(e, record);
                    }}
                  >
                    <Toggle disabled={false} showText={false} />
                  </div>
                )}
              </div>
          );
        },
      };
    }
  });

  const clearFilters = () => {
    if (showTableFilter) {
      setFilteredInfo([]);
    }
  };

  const customNoDataText = {
    emptyText: (
      <div style={{ color: "black", fontFamily: "Verizon NHG DS" }}>
        <center>
          <br></br>
          {pageName === "Cameras" && (
            <>
              <h3 style={{ fontWeight: "300" }}>No camera found</h3>
              <p style={{ fontWeight: "400" }}>
                Try adjusting your search or filters or check if there are any
                unpaired cameras for the location.
              </p>
            </>
          )}
          {pageName === "CompanionDevices" && (
            <>
              <h3 style={{ fontWeight: "300" }}>No companion devices found</h3>
              <p style={{ fontWeight: "400" }}>
                Try adjusting your search or filters.{" "}
              </p>
            </>
          )}
          <div>
            <Button use="secondary" onClick={clearFilters}>
              Remove filters
            </Button>
          </div>
        </center>
      </div>
    ),
  };

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          border: pageName === CAMERA_EVENTS ? "none" : "1px solid",
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={styles.hHeader}>{tableTitle}</div>

          <div
            style={{
              flext: 1,
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {pageName === "DiscoverCameras" && (
              <Button size="small" use="Primary">
                Associate
              </Button>
            )}
            {pageName === "CompanionDevices" && (
              <Button size="small" use="Primary">
                Add Device
              </Button>
            )}
            {pageName === "DiscoveredCameras" && (
              <SearchWithButton
                displayListType={displayListType}
                buttonLabel={buttonLabel}
                setSearchDevice={setSearchSensor}
                onButtonClick={onButtonClick}
                buttonDisable={buttonDisable}
              />
            )}
            {hasRefreshIcon && (
              <div
                style={{ flext: 1 }}
                onClick={(e) =>
                  pageName === "devices"
                    ? setRefreshDeviceTable()
                    : setRefreshDeviceTable(true)
                }
              >
                <Icon name="sync" size="large" color="#000000" />
              </div>
            )}
            {pageName !== CAMERA_EVENTS && (
              <div onClick={(e) => handlerFiltedAction()}>
                <Icon
                  name="filter"
                  size="large"
                  color={showTableFilter ? "#EE0000" : "#000000"}
                />
              </div>
            )}
          </div>
        </div>
      </Box>
      <CustomTable
        {...props}
        columnDetails={columnDetails}
        dataList={pageName === CAMERA_EVENTS ? incidentListItems : deviceList}
        searchColumns={[...searchColumns]}
        tableLoading={tableLoading}
        searchInputText={searchInputText}
        showTableFilter={showTableFilter}
        renderedColumns={renderedColumns}
        showPagination={pageName === CAMERA_EVENTS ? true : false}
        totalIncidentCount={totalIncidentCount}
        itemsPerPage={itemsPerPage}
        handleChange={handleTableChange}
        filteredInfo={filteredInfo}
        locale={
          pageName === "Cameras" || pageName === "CompanionDevices"
            ? customNoDataText
            : ""
        }
        tableName="devices"
      />
    </>
  );
};

export default DevicesTable;
